import { Box, Typography, Button } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { useDemoRole } from '../../contexts/DemoRoleContext';

/**
 * ViewAsBanner — slim amber impersonation ribbon under the beta banner.
 * Visible only while an admin is viewing the app as a real org member,
 * so it's always obvious whose lens is active and how actions are recorded.
 */
export default function ViewAsBanner() {
  const { viewingAs, personaUser, setViewAs, viewAsReadOnly } = useDemoRole();

  if (!viewingAs) return null;

  const name = personaUser?.name || viewingAs.email || 'this member';
  const roleLabel = personaUser?.title || viewingAs.role;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        px: 2,
        py: 0.75,
        bgcolor: '#fff3e0',
        color: '#e65100',
      }}
    >
      <VisibilityIcon fontSize="small" />
      <Typography variant="body2" sx={{ flexGrow: 1 }}>
        Viewing as <strong>{name}</strong> ({roleLabel}).{' '}
        {viewAsReadOnly
          ? <><strong>Read only</strong> — you can look but not change anything (Settings → Organization → View As access).</>
          : <>Actions you take are recorded as {name}, entered by you.</>}
      </Typography>
      <Button
        size="small"
        variant="outlined"
        color="inherit"
        onClick={() => setViewAs(null)}
        sx={{ textTransform: 'none', fontWeight: 700, py: 0, flexShrink: 0 }}
      >
        Exit
      </Button>
    </Box>
  );
}
